import { useUserRoles } from '@anytag/auth';
import { MarketplaceCampaignDetailType } from '@anytag/graphql';
import { Form } from '@anytag/shared-atoms';
import { DefaultFormProps } from '../types';
import { getMarketplaceInitialFormValues } from '../utils';
import { getSocialMediaTrackingFormSchema } from './schema';
import { Template } from './Template';

export const SocialMediaTrackingForm = ({ data, onSubmit, disabledFields, defaultAdvertiser }: DefaultFormProps) => {
  const { role } = useUserRoles();

  const defaultValues = getMarketplaceInitialFormValues({
    data,
    defaultAdvertiser,
    campaignType: MarketplaceCampaignDetailType.NORMAL
  });

  return (
    <Form.Provider onSubmit={onSubmit} defaultValues={defaultValues} zodSchema={getSocialMediaTrackingFormSchema(role)}>
      <Template defaultValues={defaultValues} disabledFields={disabledFields} />
    </Form.Provider>
  );
};
